const supportTypes = [
    { name: "AccessAuditing", label: `Access auditing` },
    { name: "AudioDescription", label: `Audio Description` },
    { name: "Braille", label: `Braille` },
    { name: "BritishSignLanguage", label: `British Sign Language` },
    { name: "Captioning", label: `Captioning` },
    { name: "Coaching", label: `Coaching` },
    { name: "Consultancy", label: `Consultancy` },
    { name: "EasyRead", label: `Easy Read` },
    { name: "InterpretationProvider", label: `Interpretation Provider` },
    { name: "IrishSignLanguage", label: `Irish Sign Language` },
    { name: "KnowledgeBase", label: `Knowledge Base` },
    { name: "Makaton", label: `Makaton` },
    { name: "Marketing", label: `Marketing` },
    { name: "Mentoring", label: `Mentoring` },
    { name: "SupportLine", label: `Support Line` },
    { name: "SignSupportedEnglish", label: `Sign Supported English` },
    { name: "Software", label: `Software` },
    { name: "Streaming", label: `Streaming` },
    { name: "Training", label: `Training` },
    { name: "UsabilityTesting", label: `Usability Testing` }
];
const operationIn = [
    { name: "England", label: `England` },
    { name: "Scotland", label: `Scotland` },
    { name: "Wales", label: `Wales` },
    { name: "NorthernIreland", label: `Northern Ireland` },
    { name: "Ireland", label: `Ireland` },
    { name: "Online", label: `Online` }
];
const artforms = [
    { name: "CombinedArts", label: `Combined Arts` },
    { name: "Craft", label: `Craft` },
    { name: "Dance", label: `Dance` },
    { name: "Festivals", label: `Festival` },
    { name: "FilmOrScreen", label: `Film/Screen` },
    { name: "Libraries", label: `Libraries` },
    { name: "Literature", label: `Literature` },
    { name: "Museums", label: `Museums` },
    { name: "Music", label: `Music` },
    { name: "PerformingArts", label: `Performing Arts` },
    { name: "Theatre", label: `Theatre` },
    { name: "VisualArts", label: `Visual Arts` },
];
const languages = [
    { name: 'en', label: 'English' },
    { name: 'cy', label: 'Cymraeg' },
    // {name: 'ga', label: 'Gaeilge'},
    { name: 'gd', label: 'Gaelic' }
];
const processProfileData = (_profileData, support_org_language_texts) => {
    //console.log('processProfileData', _profileData);
    if (_profileData?.draftInfo) {
        let draftInfo = JSON.parse(_profileData.draftInfo);
        _profileData = { ..._profileData, ...draftInfo };
    }
    let returnData = [
        { name: 'logo', type: 'file', title: `Logo`, value: '', description: ``, error_message: `Please upload a logo for your Support profile` },
        { name: 'name', type: 'text', title: `Name`, value: _profileData?.name, 'required': true, description: ``, error_message: `Please enter the name of your Support profile` },
        //{name:'language', type:'select', title:msg(`What is the language of your organisation?`), value:_profileData?.language, 'required':true, options:languages, description:msg(str`What language will you be submitting this profile in?`), error_message:msg(str`Please select the language for your Support profile`)},
        { name: 'language', type: 'select', title: support_org_language_texts?.support_org_language || `What is the language of your organisation?`, value: _profileData?.language, 'required': true, options: languages, description: support_org_language_texts?.support_org_language_description || `What language will you be submitting this profile in?`, error_message: support_org_language_texts?.support_org_language_error || `Please select the language for your Support profile` },
        { name: 'description', type: 'textarea', title: `Description`, value: _profileData?.description, 'required': true, description: ``, error_message: `Please enter a description of your Support profile` },
        { name: 'website', type: 'url', title: `Website`, value: _profileData?.website, description: ``, error_message: `Please enter the website for your Support profile` },
        { name: 'email', type: 'email', title: `Email`, value: _profileData?.email, description: ``, error_message: `Please enter the email address for your Support profile` },
        { name: 'phone', type: 'text', title: `Phone`, value: _profileData?.phone, description: ``, error_message: `Please enter the phone number for your Support profile` },
        { name: 'operationIn', type: 'multiselect', title: `Areas of operation`, value: _profileData?.operationIn, options: operationIn, description: ``, error_message: `Please select the areas in which your Support profile operates` },
        { name: 'supportTypes', type: 'multiselect', title: `Types of support offered`, value: _profileData?.supportTypes, options: supportTypes, description: ``, error_message: `Please select the types of support offered by your Support profile` },
        { name: 'artforms', type: 'multiselect', title: `Artforms supported`, value: _profileData?.artforms, options: artforms, description: ``, error_message: `Please select the artforms supported by your Support profile` },
    ];
    //console.log('returnData', returnData);
    return returnData;
};
export { supportTypes, operationIn, artforms, processProfileData };
